export const EVENTS_KEY = 'famlyticsEvents';
export const KEYPART_KEY = 'famlyticsKeyParts';
export const HEARTBEAT_KEY = 'famlyticsHeartbeat';
export const OVERRIDDEN_REFRESH_INTERVAL_KEY = 'famlyticsOverriddenRefreshInterval';
